<template>
    <div class="lite-nav-line">
        <div class="lite-nav-line-el" v-on:click="goProjectsGallery()">
            <div class="lite-nav-line-el-icon flex-center">
                <SVGArrowBack class="lite-nav-line-el-icon-svg"/>
            </div>
            <div class="lite-nav-line-el-text flex-center collapsable">
                Выбрать дом
            </div>
        </div>
        <div class="lite-nav-line-el" v-on:click="editMaterials()">
            <div class="lite-nav-line-el-icon flex-center">
                <SVGBrush class="lite-nav-line-el-icon-svg"/>
            </div>
            <div class="lite-nav-line-el-text flex-center collapsable">
                Редактировать дизайн
            </div>
        </div>
        <div class="lite-nav-line-el" v-on:click="createPDF('load')">
            <div class="lite-nav-line-el-icon flex-center">
                <SVGDownload class="lite-nav-line-el-icon-svg"/>
            </div>
            <div class="lite-nav-line-el-text flex-center collapsable">
                Скачать
            </div>
        </div>
        <div class="lite-nav-line-el" v-on:click="createPDF('print')">
            <div class="lite-nav-line-el-icon flex-center">
                <SVGPrint2 class="lite-nav-line-el-icon-svg"/>
            </div>
            <div class="lite-nav-line-el-text flex-center collapsable">
                Распечатать
            </div>
        </div>
        <div class="lite-nav-line-el" v-on:click="showModalShare()">
            <div class="lite-nav-line-el-icon flex-center">
                <SVGShare class="lite-nav-line-el-icon-svg"/>
            </div>
            <div class="lite-nav-line-el-text flex-center collapsable">
                Поделиться
            </div>
        </div>
    </div>
</template>

<script>
    import SVGHouse from "../../../SVG/SVGHouse";
    import SVGAdminEditRow from "../../../SVG/SVGAdminEditRow";
    import SVGArrowLeft from "../../../SVG/SVGArrowLeft";
    import SVGPhotoRotateLeft from "../../../SVG/SVGPhotoRotateLeft";
    import SVGPrint from "../../../SVG/SVGPrint";
    import SVGArrowBack from "../../../SVG/SVGArrowBack";
    import SVGBrush from "../../../SVG/SVGBrush";
    import SVGDownload from "../../../SVG/SVGDownload";
    import SVGPrint2 from "../../../SVG/SVGPrint2";
    import SVGShare from "../../../SVG/SVGShare";
    import {loadResultPDF, printResultPDF} from "../../../../reportGenerator/createPdfLite";
    import ModalShare from "../../../Modal/ModalShare";

    export default {
        name: "LeftLowerBarLiteDesign",
        components: {
            SVGShare,
            SVGPrint2,
            SVGDownload,
            SVGBrush,
            SVGArrowBack,
            SVGPrint,
            SVGPhotoRotateLeft,
            SVGArrowLeft,
            SVGAdminEditRow,
            SVGHouse
        },
        computed: {
            designID(){
                return this.$store.state.route.params.designID;
            }
        },
        methods: {
            showModalShare() {
                this.$modal.show(ModalShare, {url: window.parent.location.href}, {
                    name: 'modalShare',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
            goProjectsGallery() {
                this.$router.push({name: 'liteProjects'}).catch(() => {});
            },
            editMaterials() {
                this.$router.push({
                    name: 'lightDesignMaterialsEmpty',
                    params: {idDesign: this.designID}
                }).catch(() => {});
            },
            async createPDF(type) {
                let rule = {
                    load: loadResultPDF,
                    print: printResultPDF
                }
                if(!this.$store.state.resultImg.allUploaded){
                    alert('Дождитесь загрузки изображений ...');
                    return;
                }
                const photos = await this.$store.dispatch("resultImg/GET_UPLOADED_PHOTOS_BASE64", {
                    idsPhotos: Object.keys(this.$store.getters["active/GET_ALL_PHOTO"]),
                    idsDesigns: [this.$store.state.route.params.designID]
                });
                const promisePDF = rule[type](this.$store.getters["costLite/PRODUCTS_COST"], photos);
                await this.$store.dispatch('IN_PROGRESS', promisePDF);
            },
        }
    }
</script>

<style scoped>
    @media (min-width: 1270px) {
        .collapsed {
            display: none !important;
        }
    }
    @media (max-width: 1270px) {
        .collapsable {
            display: none !important;
        }
    }
    .lite-nav-line {
        display: grid;
        grid-auto-flow: column dense;
        grid-column-gap: 30px;
        width: max-content;
        height: 100%;
        margin: 0 40px;
    }

    .lite-nav-line-el {
        display: flex;
        flex-direction: row;
        cursor: pointer;
        user-select: none;
        color: #292929;
        transition: color 0.35s ease;
    }
    .lite-nav-line-el:hover {
        color: #cf2c2f;
    }

    .lite-nav-line-el-icon {
        margin-right: 20px;
    }

    .lite-nav-line-el-icon-svg {
        width: 20px;
        height: 20px;
    }
    .lite-nav-line-el-text {
        font-size: 14px;

    }
</style>
